import React, { useEffect, useMemo, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { PATH } from '../../constants/router'
// import { useAppParamsContext } from '../../context/AppParamsContext'
import appUserService from '../../services/appUserService'
import { getPartnerVehicleResult, setPartnerVehicleResult } from '../../helper/partnerSessionStore'
import LayoutPartner from '../../components/FeaturesComponent/layoutPartner'
import HeaderPartner from '../../components/FeaturesComponent/headerPartner'
import AutoPayBanner from './components/AutoPayBanner'
import ExpandedUtilitiesSection from '../AutoTrafficFineNotificationLookup/components/ExpandedUtilitiesSection'
import ResultCard from './components/ResultCard'
// import ViettelMoneyHeader from '../AutoTrafficFineNotificationLookup/components/ViettelMoneyHeader'
import ViolationInlineList from './components/ViolationInlineList'
import { loadHomeCache, saveHomeCache } from '../AutoTrafficFineNotificationLookup/utils/homeCache'
import trafficFineBell from '../../assets/images/traffic_fine_bell.png'
import trafficFineBgHero from '../../assets/images/traffic_fine_bg_hero.jpg'
import trafficFineUtilityPlaceholder from '../../assets/images/traffic_fine_utility_placeholder.png'
import '../AutoTrafficFineNotificationLookup/index.scss'
import './index.scss'
import FixedBottom from '../../components/BasicComponent/FixedBottom'
import BaseButton from '../../components/BasicComponent/BaseButton'

export default function TrafficFineCheckResult() {
  const history = useHistory()
  // const { isHeaderMiniApp } = useAppParamsContext()
  const [violationCount, setViolationCount] = useState(null)
  const [homeIcons, setHomeIcons] = useState([])
  const [homeBanners, setHomeBanners] = useState([])
  const [homeConfigLoading, setHomeConfigLoading] = useState(false)

  const banner = homeBanners?.[0]

  const data = useMemo(() => {
    const payload = getPartnerVehicleResult()

    if (!payload?.plate) {
      return {
        plate: '',
        carTypeLabel: '',
        carTypeValue: null,
        checkedAt: null,
        isAPIError: true,
        isVehicleWarning: false,
        message: 'Thiếu dữ liệu, vui lòng thử lại!',
        phoneNumber: '',
        stationId: '',
        violationCount: null
      }
    }

    return {
      plate: payload.plate || '',
      carTypeLabel: payload.carTypeLabel || '',
      carTypeValue: payload.carTypeValue ?? null,
      checkedAt: payload.checkedAt ? new Date(payload.checkedAt) : null,
      isAPIError: String(payload.isAPIError) === '1' || payload.isAPIError === 1 || payload.isAPIError === true,
      isVehicleWarning: String(payload.isVehicleWarning) === '1' || payload.isVehicleWarning === 1 || payload.isVehicleWarning === true,
      message: payload.message || '',
      phoneNumber: payload.phoneNumber || '',
      stationId: payload.stationId || '',
      violationCount: payload.violationCount ?? null,
      activePkg: payload.activePkg || null
    }
  }, [])

  useEffect(() => {
    let alive = true

    setHomeConfigLoading(true)
    const cached = loadHomeCache()
    if (cached) {
      setHomeIcons(cached.homeIcons || [])
      setHomeBanners(cached.homeBanners || [])
      setHomeConfigLoading(false)
      return () => {
        alive = false
      }
    }

    Promise.all([appUserService.getHomePageConfigPartner({}), appUserService.getStationBannersPartner({})])
      .then(([cfgRes, bannerRes]) => {
        if (!alive) return

        const utilities = (Array.isArray(cfgRes?.data?.data) && cfgRes.data.data) || (Array.isArray(cfgRes?.data) && cfgRes.data) || []
        const banners = (Array.isArray(bannerRes?.data?.data) && bannerRes.data.data) || (Array.isArray(bannerRes?.data) && bannerRes.data) || []

        setHomeIcons(utilities)
        setHomeBanners(banners)
        saveHomeCache({ homeIcons: utilities, homeBanners: banners })
      })
      .catch(() => {
        if (!alive) return
        setHomeIcons([])
        setHomeBanners([])
      })
      .finally(() => {
        if (!alive) return
        setHomeConfigLoading(false)
      })

    return () => {
      alive = false
    }
  }, [])

  return (
    <LayoutPartner>
      <HeaderPartner title={'Kết quả tra cứu'} />
      <div className="TrafficFineLookup TrafficFineCheckResult">
        <div className="traffic-fine-hero-bg" style={{ backgroundImage: `url(${trafficFineBgHero})` }} />

        <div className="traffic-fine-content" style={{ paddingTop: '20px' }}>
          {/* Legacy header logic (kept for reference)
          {isHeaderMiniApp ? (
            <ViettelMoneyHeader onBack={() => history.goBack()} title="Kết quả tra cứu" variant="result" />
          ) : (
            <div className="traffic-fine-header-space" />
          )}
          */}
          <div className="traffic-fine-result-main">
            <ResultCard
              isAPIError={data.isAPIError}
              isVehicleWarning={data.isVehicleWarning}
              message={data.message}
              plateNumber={data.plate}
              checkedAtDate={data.checkedAt}
              carTypeLabel={data.carTypeLabel}
              violationCount={violationCount}
            />

            {!data.isAPIError && data.activePkg ? (
              <div className="traffic-fine-manage-btn-wrap">
                <button
                  type="button"
                  className="traffic-fine-manage-btn"
                  onClick={() => {
                    const prev = getPartnerVehicleResult?.() || {}
                    setPartnerVehicleResult({
                      ...prev,
                      plate: data.plate || prev.plate,
                      carTypeValue: data.carTypeValue ?? prev.carTypeValue,
                      carTypeLabel: data.carTypeLabel || prev.carTypeLabel,
                      activePkg: data.activePkg || prev.activePkg
                    })
                    history.push(PATH.AUTO_TRAFFIC_FINE_NOTIFICATION_PACKAGE_INFO)
                  }}>
                  <span className="traffic-fine-manage-btn-left">
                    <img src={trafficFineBell} alt="" />
                    <span>Quản lý gói kiểm tra tự động</span>
                  </span>
                  <span className="traffic-fine-manage-btn-right">›</span>
                </button>
              </div>
            ) : null}

            {!data.isAPIError && data.isVehicleWarning ? (
              <ViolationInlineList
                licensePlate={data.plate}
                carTypeLabel={data.carTypeLabel}
                vehicleType={data.carTypeValue}
                autoOpen
                onCountChange={setViolationCount}
              />
            ) : null}

            <div className="traffic-fine-result-bottom-block">
              <AutoPayBanner
                mx={0}
                mt={0}
                promoImg={banner?.bannerImageUrl}
                loading={homeConfigLoading}
                onClick={() => {
                  if (banner?.bannerUrl) window.location.href = banner.bannerUrl
                }}
              />

              <ExpandedUtilitiesSection
                loading={homeConfigLoading}
                utilityIcon={trafficFineUtilityPlaceholder}
                utilities={homeIcons.map((it) => ({
                  key: it.stationHomePageConfigId,
                  label: it.title,
                  icon: it.imageUrl,
                  linkNavigation: it.linkNavigation,
                  navigationType: it.navigationType
                }))}
              />
            </div>

            <FixedBottom elementPaddingBottom={'LayoutPartner'}>
              <BaseButton onClick={() => history.goBack()}>Tra cứu xe khác</BaseButton>
            </FixedBottom>
            {/* <div className="traffic-fine-result-action-wrap">
              <button type="button" className="traffic-fine-result-action-btn" onClick={() => history.goBack()}>
                Tra cứu xe khác
              </button>
            </div> */}
          </div>
        </div>
      </div>
    </LayoutPartner>
  )
}
